import { GoogleMapsAPIWrapper } from '@agm/core';
import { Directive, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { LoggerService } from '../../services';
import { MapService } from '../../services';
import { OnDestroy } from '@angular/core';
import { GoogleAnalyticsService } from '../../services';
import { MarkerPoint } from './marker.point';
import { TaggedLogger } from '../../services/taggedLogger';

@Directive({
  selector: 'agm-map-directions',
})
export class DirectionsMapDirective implements OnDestroy, OnChanges {
  private logger: TaggedLogger;

  public _origin: MarkerPoint;
  public _destination: MarkerPoint;

  public directionsService: any;
  public _color: any;
  public _opacity: any;
  public _directions: any;
  public _earliestPickup: any;

  public directionsDisplays: Array<any>;
  public directionsPolylines: Array<any>;

  constructor(
    private gmapsApi: GoogleMapsAPIWrapper,
    private googleAnalyticsService: GoogleAnalyticsService,
    private mapService: MapService,
    loggerService: LoggerService,
  ) {
    this.directionsDisplays = [];
    this.directionsPolylines = [];
    this.originChange = new EventEmitter<MarkerPoint>();
    this.destinationChange = new EventEmitter<MarkerPoint>();
    this.colorChanged = new EventEmitter<any>();
    this.logger = loggerService.taggedLogger('DirectionsMapDirective');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['origin'] || changes['destination'] || changes['earliestPickup']) {
      this.updateDirections();
    }
  }

  ngOnDestroy() {
    this.clearAllDirections();
    this.clearAllPolylines();
  }

  private clearAllDirections() {
    for (var j = this.directionsDisplays.length - 1; j >= 0; j--) {
      var directionsDisplay = this.directionsDisplays[j];

      directionsDisplay.setMap(null);

      this.directionsDisplays.splice(j, 1);
    }
  }

  private clearAllPolylines() {
    for (var j = this.directionsPolylines.length - 1; j >= 0; j--) {
      var directionsPolyline = this.directionsPolylines[j];

      directionsPolyline.setMap(null);

      this.directionsPolylines.splice(j, 1);
    }
  }

  @Output() originChange: EventEmitter<MarkerPoint>;
  @Input('origin')
  set origin(value: MarkerPoint) {
    this._origin = value;
  }

  @Output() destinationChange: EventEmitter<MarkerPoint>;

  @Input('destination')
  set destination(value: MarkerPoint) {
    this._destination = value;
  }

  @Output() colorChanged: EventEmitter<any>;
  @Input('color')
  set color(value: any) {
    this._color = value;
  }
  get color() {
    return this._color;
  }

  @Input('opacity')
  set opacity(value: any) {
    this._opacity = value;
  }
  get opacity() {
    return this._opacity;
  }

  @Input('directions')
  set directions(value: any) {
    this._directions = value;
  }
  get directions() {
    return this._directions;
  }

  @Input('earliestPickup')
  set earliestPickup(value: Date) {
    this._earliestPickup = value;
  }
  get earliestPickup() {
    return this._earliestPickup;
  }

  updateDirections() {
    this.logger.trace('Updating directions');
    var that = this;

    this.clearAllDirections();

    this.gmapsApi.getNativeMap().then((map) => {
      if (!that._origin || !that._destination) {
        return;
      }

      //that.directionsService = new google.maps.DirectionsService;

      var latLngA = new google.maps.LatLng(that._origin.latitude, that._origin.longitude);
      var latLngB = new google.maps.LatLng(that._destination.latitude, that._destination.longitude);
      this.googleAnalyticsService.eventEmitter(
        'update_directions',
        'location_services',
        'get_native_map',
        `${latLngA} ${latLngB}`,
      );
      that.plotDirections(latLngA, latLngB, map);
    });
  }

  plotDirections(start, end, map) {
    this.logger.trace('Plotting directions...');

    var request = {
      origin: start,
      destination: end,
      travelMode: (google.maps as any).DirectionsTravelMode.DRIVING,
      avoidTolls: false,
      avoidHighways: false,
      earliestDeparture: this.earliestPickup,
    };

    var that = this;

    if (this.directions) {
      this.processDirections(this.directions, that, map);
    } else {
      this.mapService.GetDirections(request).then((response) => {
        //console.log('** ++ DIRECTIONS RESPONSE: ', response);
        that.processDirections(response, that, map);
      });
    }
  }

  private processDirections(response: any, that: any, map: any) {
    that.clearAllPolylines();

    //console.log('******************** DIR RES: ', response);

    if (response && response.status == google.maps.DirectionsStatus.OK) {
      var routes = response.routes;
      var colors = ['red', 'green', 'orange', 'yellow', 'black'];

      that._origin.address = response.routes[0].legs[0].start_address;
      that._destination.address = response.routes[0].legs[0].end_address;
      that.originChange.emit(that._origin);
      that.destinationChange.emit(that._destination);
      that.colorChanged.emit(that._color);

      that.googleAnalyticsService.eventEmitter('plot_directions', 'location_services', 'route');
      // Loop through each route
      for (var i = 0; i < routes.length; i++) {
        var decodedPath = google.maps.geometry.encoding.decodePath(
          routes[i].overview_polyline.points,
        );
        var decodedLevels = that.decodeLevels('BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB');

        var setRegion = new (google.maps as any).Polyline({
          path: decodedPath,
          levels: decodedLevels,
          strokeColor: that.color ? that.color : colors[i % 5],
          strokeWeight: 4,
          strokeOpacity: that.opacity ? that.opacity : 0.3,
          map: map,
        });

        that.directionsPolylines.push(setRegion);

        //var directionsDisplay = new google.maps.DirectionsRenderer({
        //    map: map,
        //    directions: response,
        //    routeIndex: i,
        //    suppressMarkers: true,
        //    preserveViewport: true,
        //    polylineOptions: {
        //        strokeColor: that.color ? that.color : colors[i % 5],
        //        strokeWeight: 4,
        //        strokeOpacity: .3
        //    }
        //});

        //that.directionsDisplays.push(directionsDisplay);
      }
    } else {
      this.logger.warn('Route not found'); // todo: double check level, is this expected?
    }
  }

  private getcomputeDistance(latLngA: any, latLngB: any) {
    return (google.maps.geometry.spherical.computeDistanceBetween(latLngA, latLngB) / 1000).toFixed(
      2,
    );
  }

  private decodeLevels(encodedLevelsString) {
    var decodedLevels = [];

    for (var i = 0; i < encodedLevelsString.length; ++i) {
      var level = encodedLevelsString.charCodeAt(i) - 63;
      decodedLevels.push(level);
    }
    return decodedLevels;
  }
}
